import api from './request'

const findStockByKeyword = (keyword, teamId, createdTime, page, size) => {
    return api.postPromise('remnant/findStockByKeyword', {
        keyword, teamId, page, size
    },createdTime, null, true)
}

const findStockByUser = (page,size,teamId,skuId) => {
    return api.getPromise('remnant/findStockByUser', {
        page,
        size,
        teamId,
        skuId,
    }, null, true)
}

const findStocksV2 = (query) => {
    return api.postPromise('remnant/findStocksV2', {}, query, null , true)
}

export default {
    findStockByKeyword,
    findStockByUser,
    findStocksV2,
}



// WEBPACK FOOTER //
// ./src/request/remnantApi.js